import React, { useState } from 'react';
import { DateFieldConfiguration } from '../../../api/ConfigApi';
import { AuthData, withAuthContext } from '../../../context/auth';
import { dayjs } from '../../../date-util';
import { getDateErrors } from '../../../util/util';
import DefaultDatePicker from '../../form/DefaultDatePicker';

interface Props {
	field: DateFieldConfiguration;
	value?: any;
	isDisabled?: boolean;
	required?: boolean;
	onChange?: (value: string) => void;
	authData: AuthData;
}

const DateField = (props: Props) => {
	const { field, value, isDisabled, required, onChange, authData } = props;
	let initialValue = value ? value : null;
	if (initialValue) {
		const newDate = dayjs(initialValue);
		const validDate = newDate.isValid();
		let zonedEffectiveDate;
		if (validDate) {
			newDate.hour(0);
			newDate.minute(0);
			newDate.second(0);
			zonedEffectiveDate = newDate.tz(authData.auth.timezone).toDate();
		}
		initialValue = zonedEffectiveDate;
	}

	const createDateFromDateString = (date: string) => {
		if (!date) {
			return null;
		}

		const newDate = dayjs(date);
		const validDate = newDate.isValid();
		let zonedEffectiveDate = null;
		if (validDate) {
			newDate.hour(0);
			newDate.minute(0);
			newDate.second(0);
			zonedEffectiveDate = newDate.tz(authData.auth.timezone).toDate();
		}
		return zonedEffectiveDate;
	};

	const minAllowedDate = field.minimum
		? createDateFromDateString(field.minimum)
		: null;
	const maxAllowedDate = field.maximum
		? createDateFromDateString(field.maximum)
		: null;

	const [currDate, setCurrDate] = useState<Date>(initialValue);
	const dateError = getDateErrors(
		currDate,
		minAllowedDate,
		maxAllowedDate,
		!field.optional,
		authData,
		false,
		field.precision ? field.precision : '',
	);

	const updateDate = (date: Date) => {
		// All date values being sent for configurable date fields (within FieldEditorForm) should be in the format YYYY-MM-DD
		// val is in the format YYYY/MM/DD so when we send the updated date, we want to swap out / for -
		const validDate = date && !isNaN(date.getTime());
		setCurrDate(date);
		const updatedDate = validDate ? dayjs(date).format() : '';
		onChange(updatedDate);
	};

	return (
		<DefaultDatePicker
			id={field.name}
			label={field.title}
			error={!isDisabled && !dateError.isValid}
			errorMessage={dateError.message}
			precision={field.precision ? field.precision : 'day'}
			value={currDate}
			initialFocusedDate={currDate}
			disabled={isDisabled}
			required={required}
			minDate={minAllowedDate}
			maxDate={maxAllowedDate}
			showCalendar={(field as DateFieldConfiguration).showCalendar}
			style={{ marginRight: '10px', width: '100%', marginTop: '0px' }}
			onChange={updateDate}
		/>
	);
};

export default withAuthContext<Props>(DateField);
